module.exports = __webpack_public_path__ + "static/media/circle_trailer_icon.3fea3026.svg";